export default "__VITE_ASSET__6bc12c71__"